export enum RequestMethod {
  GET = "GET",
  POST = "POST",
}

export enum RequestName {
  IP = "ip",
  TERMS_OF_USE = "terms_of_use",
  PRIVACY_PLOICY = "privacy_policy",
  GET_BALANCE = "get_balance",
  GET_REQUESTS = "get_ipchecker_requests",
  GET_SUBSCRIPTION = "get_ipchecker_subscription",
  // GET /api_key_summary — the account, plan and requests behind a key
  // (cabinet API page). Needs a user key: never sent anonymously.
  API_KEY_SUMMARY = "api_key_summary",
  CHECK_IP = "check-ip",
  // POST /port-check — on-demand, called through usePortCheck (not
  // useApiRequest: it needs a 25 s timeout and a fresh call per click).
  PORT_CHECK = "port-check",
  // GET /port-check/availability — public, no auth; gates whether the
  // port-check block is rendered at all (usePortCheckAvailability).
  PORT_CHECK_AVAILABILITY = "port-check/availability",
  CREATE_INVOICE = "create_invoice",
  GET_INVOICE = "get_invoice",
  UPDATE_INVOICE = "update_invoice",
  GET_ACCOUNT_DETAILS = "get_account_details",
  GET_INVITER_STATS = "get_inviter_stats",
  // Referral write-side (route strings verbatim from api/routes/referral.py —
  // a wrong string 404s silently and the feature just renders empty).
  REFERRAL_TRANSFER = "referral/transfer",
  REFERRAL_PAYOUT_CURRENCIES = "referral/payout_currencies",
  REFERRAL_PAYOUT_REQUEST = "referral/payout_request",
  REFERRAL_PAYOUTS = "referral/payouts",
  GET_NEWS = "get_news",
  GET_INVOICES_HISTORY = "get_user_invoices",
  BUY_SUBSCRIPTION = "buy_subscription",
  GET_PURCHASES = "get_purchases",
  REGISTER_ACCOUNT = "register.php",
  LOG_IN_ACCOUNT = "login.php"
}

export type Params = {
  apiToken?: string;
  method: RequestMethod;
  name: RequestName;
  checkIpParams?: {
    queryIp: string;
    mode?: boolean;
  };
  getInvoiceParams?: {
    invoiceId: string | number;
  };
  createInvoiceParams?: {
    currency: string;
    network: string;
    amount: number;
  };
  updateInvoiceParams?: {
    invoiceId: string;
    currency: string;
    network: string;
  };
  buySubscriptionParams?: {
    subscriptionId: number;
  };
  // Trigger for POST /referral/transfer. The endpoint takes an EMPTY body —
  // the server always moves the full available balance, the client NEVER sends
  // an amount. Keep the object in component state: its identity change is what
  // re-fires the request; absence (undefined) means "don't call yet".
  referralTransferParams?: {
    submit: boolean;
  };
  // Body for POST /referral/payout_request. Amounts are server-computed; the
  // client only picks a currency and an address. Keep in state (see above).
  payoutRequestParams?: {
    currency: string;
    address: string;
  };
};
